module.exports = __webpack_public_path__ + "img/alper-logo.27e3e6b6.png";